interface PaymentPlanInterface {
  currencyUnit: string;
  interval: string;
  name: string;
  description: string;
  planCode: string;
  price: number;
  unitAmountInCents: { USD: number };
}

class PaymentPlans {
  plans: PaymentPlanInterface[];

  constructor(plans) {
    this.plans = plans;
  }
}

export default PaymentPlans;
